// dna_frontend/src/pages/SearchExport.js
// (*** ĐÃ CẬP NHẬT: Bổ sung trạng thái "Ở xa không về" ***)

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { saveAs } from 'file-saver'; 

// --- CÁC HẰNG SỐ OPTIONS ---
const TRANG_THAI_THU_MAU_DB = [
  { key: 'chua_thu', value: 'Chưa thu', color: 'gray' },
  { key: 'da_thu_mau', value: 'Đã thu mẫu', color: 'green' },
  { key: 'sai_dien', value: 'Sai diện', color: 'orange' },
  { key: 'khong_co_mat', value: 'Không có mặt', color: 'red' },
  { key: 'khong_thu_mau', value: 'Không thu mẫu', color: 'red' },
];

const TRANG_THAI_RA_SOAT_OPTIONS = [
  { key: '', value: '-- Tất cả TT Rà soát --' }, // Thêm option rỗng để mặc định
  { key: 'chua_ra_soat', value: 'Chưa rà soát' },
  { key: 'xac_nhan', value: 'Xã xác nhận (Đồng ý)' }, 
  { key: 'khong_lien_lac', value: 'Xã báo: Không liên lạc được' },
  { key: 'o_xa_khong_ve', value: 'Xã báo: Ở xa không về' }, // (*** MỚI BỔ SUNG ***)
  { key: 'khong_ve_dung_hen', value: 'Xã báo: Không về đúng hẹn' },
  { key: 'khong_nhu_cau', value: 'Xã báo: Không có nhu cầu' },
  { key: 'qua_yeu', value: 'Xã báo: Quá yếu / Ốm đau' },
  { key: 'da_thu_mau_truoc', value: 'Đã thu mẫu trước 01/7/2025'},
  { key: 'de_nghi_xoa', value: 'Đề nghị xóa'},
  { key: 'du_phong', value: 'Thân nhân dự phòng (3,4...)'},
  { key: 'khac', value: 'Xã báo: Khác' },
];

const NGUON_DU_LIEU_OPTIONS = [
  { key: '', value: '-- Tất cả Nguồn --' },
  { key: 'admin_upload', value: 'Admin Upload' },
  { key: 'xa_them_moi', value: 'Xã thêm mới' },
  { key: 'tinh_them_moi', value: 'Tỉnh/Admin thêm'},
];

const TRANG_THAI_CHINH_SUA_OPTIONS = [
  { key: '', value: '-- Tất cả TT Sửa --' },
  { key: 'goc', value: 'Gốc' },
  { key: 'da_sua', value: 'Đã sửa' },
];

// --- COMPONENT MODAL SỬA ---
const EditModal = ({ item, xaPhuongList, onClose, onSave }) => {
    // Khởi tạo state, đảm bảo các trường không bị null/undefined
    const [formData, setFormData] = useState({ 
        ...item,
        xa_id: item.xa_id || '', 
        nam_sinh: item.nam_sinh || '',
        cccd: item.cccd || '',
        dia_chi: item.dia_chi || '',
        ghi_chu: item.ghi_chu || ''
    });
    const [error, setError] = useState('');

    useEffect(() => {
        // Format ngày tháng để hiển thị đúng trong input date
        if (item.ngay_cap_nhat_thu_mau) {
            setFormData(prev => ({
                ...prev,
                ngay_cap_nhat_thu_mau: new Date(item.ngay_cap_nhat_thu_mau).toISOString().split('T')[0]
            }));
        }
    }, [item]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        
        if (!formData.ho_ten || !formData.nam_sinh || !formData.cccd || !formData.xa_id) {
            setError("Vui lòng nhập đầy đủ: Họ tên, Năm sinh, CCCD và Xã/Phường.");
            return;
        }

        try {
            await api.put(`/than-nhan/admin/${item.id}`, formData);
            alert("Cập nhật thành công!");
            onSave(); 
            onClose();
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi cập nhật');
        }
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
        }}>
            <div style={{
                background: 'white', padding: '20px', borderRadius: '8px', width: '600px', maxHeight: '90vh', overflowY: 'auto'
            }}>
                <h2>Sửa Thông tin Thân nhân</h2>
                {error && <p style={{color: 'red', fontWeight: 'bold'}}>{error}</p>}
                
                <form onSubmit={handleSubmit} style={{display: 'grid', gap: '10px'}}>
                    <div><label>Họ tên (*):</label><input className="form-control" name="ho_ten" value={formData.ho_ten} onChange={handleChange} required /></div>
                    
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px'}}>
                        <div><label>Năm sinh (*):</label><input className="form-control" name="nam_sinh" value={formData.nam_sinh} onChange={handleChange} required /></div>
                        <div><label>CCCD (3 số cuối) (*):</label><input className="form-control" name="cccd" value={formData.cccd} onChange={handleChange} required /></div>
                    </div>

                    <div><label>Địa chỉ:</label><input className="form-control" name="dia_chi" value={formData.dia_chi} onChange={handleChange} /></div>
                    
                    <div>
                        <label>Xã/Phường (*):</label>
                        <select className="form-control" name="xa_id" value={formData.xa_id} onChange={handleChange} required>
                            <option value="">-- Chọn Xã --</option>
                            {xaPhuongList.map(xa => <option key={xa.id} value={xa.id}>{xa.ten_xa}</option>)}
                        </select>
                    </div>

                    <div style={{borderTop: '1px solid #ccc', margin: '10px 0'}}></div>

                    <div>
                        <label>Trạng thái Rà soát (Xã):</label>
                        <select className="form-control" name="trang_thai_ra_soat" value={formData.trang_thai_ra_soat} onChange={handleChange}>
                             {TRANG_THAI_RA_SOAT_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
                        </select>
                    </div>

                    <div><label>Ghi chú (Rà soát):</label><textarea className="form-control" name="ghi_chu" value={formData.ghi_chu} onChange={handleChange} /></div>

                    <div style={{borderTop: '1px solid #ccc', margin: '10px 0'}}></div>

                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px'}}>
                        <div>
                            <label>Trạng thái Thu mẫu (Tỉnh):</label>
                            <select className="form-control" name="trang_thai_thu_mau" value={formData.trang_thai_thu_mau} onChange={handleChange}>
                                {TRANG_THAI_THU_MAU_DB.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
                            </select>
                        </div>
                        <div>
                            <label>Ngày thu mẫu:</label>
                            <input type="date" className="form-control" name="ngay_cap_nhat_thu_mau" value={formData.ngay_cap_nhat_thu_mau || ''} onChange={handleChange} />
                        </div>
                    </div>

                    <div style={{marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px'}}>
                        <button type="button" onClick={onClose} style={{padding: '8px 15px', cursor: 'pointer'}}>Hủy</button>
                        <button type="submit" style={{padding: '8px 15px', background: 'blue', color: 'white', border: 'none', cursor: 'pointer'}}>Lưu thay đổi</button>
                    </div>
                </form>
            </div>
            <style>{` .form-control { width: 100%; padding: 8px; margin-top: 5px; box-sizing: border-box; } `}</style>
        </div>
    );
};


// --- COMPONENT CHÍNH ---
function SearchExport() {
  const user = JSON.parse(localStorage.getItem('user'));
  const isUserXa = user?.role === 'xa';
  const isAdmin = user?.role === 'admin'; 

  const [searchParams, setSearchParams] = useState({
    ten_tn: '', ten_ls: '', trang_thai_rs: '', nguon: '', 
    sua: '', dc01: '', xa_id: '', trang_thai_tm: '', ngay_thu_mau: ''
  });
  const [xaPhuongList, setXaPhuongList] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit, setLimit] = useState(50); 
  
  // State cho Modal Sửa
  const [editingItem, setEditingItem] = useState(null);

  useEffect(() => {
    const fetchXaPhuong = async () => {
      if (!isUserXa) {
        try {
          const res = await api.get('/data/xaphuong');
          setXaPhuongList(res.data);
        } catch (err) { console.error("Lỗi tải danh sách xã:", err); }
      }
    };
    fetchXaPhuong();
  }, [isUserXa]); 

  const handleSearchChange = (e) => {
    setSearchParams({ ...searchParams, [e.target.name]: e.target.value });
  };

  const performSearch = async (pageToSearch) => {
    setLoading(true);
    setError('');
    try {
      const paramsToSubmit = { ...searchParams };
      if (isUserXa) { delete paramsToSubmit.xa_id; }
      paramsToSubmit.page = pageToSearch;
      paramsToSubmit.limit = limit;
      
      const queryString = new URLSearchParams(paramsToSubmit).toString();
      const res = await api.get(`/than-nhan/search-advanced?${queryString}`);
      
      setResults(res.data.data); 
      setTotalPages(res.data.totalPages);
      setCurrentPage(res.data.currentPage);

    } catch (err) { 
      setError('Lỗi khi tìm kiếm: ' + (err.response?.data?.message || err.message));
      setResults([]); 
    } finally {
      setLoading(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1); 
    performSearch(1); 
  };
  
  const handlePageChange = (newPage) => {
      if (newPage >= 1 && newPage <= totalPages) {
          setCurrentPage(newPage);
          performSearch(newPage); 
      }
  };

  const handleExport = async () => {
     setLoading(true); 
     try {
       const paramsToSubmit = { ...searchParams };
       if (isUserXa) { delete paramsToSubmit.xa_id; }
       const queryString = new URLSearchParams(paramsToSubmit).toString();
       const response = await api.get(`/than-nhan/export?${queryString}`, { responseType: 'blob' });
       let fileName = 'DanhSachThanNhanADN.xlsx';
       saveAs(response.data, fileName);
     } catch (err) {
       setError('Lỗi khi xuất Excel: ' + (err.response?.data?.message || err.message));
     } finally {
       setLoading(false);
     }
  };
  
  const getStatusColor = (status) => {
    switch(status) {
      case 'xac_nhan': return 'green';
      case 'chua_ra_soat': return 'gray';
      case 'qua_yeu': case 'khong_lien_lac': case 'khong_ve_dung_hen': case 'khong_nhu_cau': case 'o_xa_khong_ve': case 'khac': case 'de_nghi_xoa': case 'du_phong': return 'red';
      case 'da_thu_mau_truoc': return 'blue';
      default: return 'black';
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Tìm kiếm Nâng cao & Xuất Excel</h1>
      
      <form onSubmit={handleSearchSubmit} style={{ background: '#f4f4f4', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
        <h3>Bộ lọc tìm kiếm</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '15px' }}>
          {!isUserXa && (
             <select name="xa_id" value={searchParams.xa_id} onChange={handleSearchChange} style={{padding: '8px'}}>
                <option value="">-- Tất cả Xã --</option>
                {xaPhuongList.map(xa => <option key={xa.id} value={xa.id}>{xa.ten_xa}</option>)}
             </select>
          )}
          <input type="text" name="ten_tn" value={searchParams.ten_tn} onChange={handleSearchChange} placeholder="Tên thân nhân..." style={{padding: '8px'}}/>
          <input type="text" name="ten_ls" value={searchParams.ten_ls} onChange={handleSearchChange} placeholder="Tên liệt sĩ..." style={{padding: '8px'}}/>
          
          <select name="trang_thai_rs" value={searchParams.trang_thai_rs} onChange={handleSearchChange} style={{padding: '8px'}}>
            {TRANG_THAI_RA_SOAT_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
          </select>

           <select name="trang_thai_tm" value={searchParams.trang_thai_tm} onChange={handleSearchChange} style={{padding: '8px'}}>
             <option value="">-- Tất cả TT Thu mẫu --</option>
             {TRANG_THAI_THU_MAU_DB.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
          </select>
          
          <input type="date" name="ngay_thu_mau" value={searchParams.ngay_thu_mau} onChange={handleSearchChange} style={{padding: '8px'}} />
          
          <select name="nguon" value={searchParams.nguon} onChange={handleSearchChange} style={{padding: '8px'}}>
             {NGUON_DU_LIEU_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
          </select>
        </div>
        <button type="submit" disabled={loading} style={{ background: '#007bff', color: 'white', marginTop: '15px', padding: '10px 15px', border: 'none', cursor: 'pointer' }}>
          {loading ? 'Đang tìm...' : 'Tìm kiếm'}
        </button>
      </form>

      <button onClick={handleExport} disabled={loading || results.length === 0} style={{ background: 'darkgreen', color: 'white', padding: '10px 15px', marginBottom: '20px', cursor: 'pointer', border: 'none' }}>
        Xuất Excel (theo bộ lọc)
      </button>

      {error && <p style={{ color: 'red', fontWeight: 'bold' }}>Lỗi: {error}</p>}

      {/* Phân trang */}
      {totalPages > 0 && (
          <div style={{ margin: '20px 0', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
              <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>Trang đầu</button>
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Trang trước</button>
              <span>Trang <strong>{currentPage}</strong> / {totalPages}</span>
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Trang sau</button>
              <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Trang cuối</button>
          </div>
      )}

      <h3>Kết quả tìm kiếm ({results.length} dòng)</h3>
      <div style={{maxHeight: '60vh', overflowY: 'auto'}}> 
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
          <thead>
            <tr style={{ background: '#f0f0f0', position: 'sticky', top: 0 }}> 
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Họ tên</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Năm sinh</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>CCCD</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Địa chỉ</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Xã</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Liệt Sĩ (liên quan)</th> 
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>TT Rà soát</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>TT Thu mẫu</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Ngày thu mẫu</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Nguồn</th>
              {isAdmin && <th style={{ padding: '8px', border: '1px solid #ccc' }}>Hành động</th>}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="11" style={{textAlign: 'center', padding: '20px'}}>Đang tải...</td></tr>}
            {!loading && results.map(tn => (
              <tr key={tn.id}>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.ho_ten}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.nam_sinh}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.cccd}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.dia_chi}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.ten_xa}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc', fontStyle: 'italic', color: '#555' }}>
                   {tn.DanhSach_LietSi}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc', color: getStatusColor(tn.trang_thai_ra_soat) }}>
                   {TRANG_THAI_RA_SOAT_OPTIONS.find(o => o.key === tn.trang_thai_ra_soat)?.value || tn.trang_thai_ra_soat}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc', color: TRANG_THAI_THU_MAU_DB.find(o=>o.key === tn.trang_thai_thu_mau)?.color, fontWeight: 'bold' }}>
                   {TRANG_THAI_THU_MAU_DB.find(o => o.key === tn.trang_thai_thu_mau)?.value || tn.trang_thai_thu_mau}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                  {(tn.trang_thai_thu_mau !== 'chua_thu' && tn.ngay_cap_nhat_thu_mau)
                    ? new Date(tn.ngay_cap_nhat_thu_mau).toLocaleString('vi-VN').split(' ')[1] 
                    : ''}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.nguon_du_lieu}</td>
                
                {isAdmin && (
                    <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                        <button 
                            onClick={() => setEditingItem(tn)}
                            style={{padding: '5px 10px', background: '#ffc107', border: 'none', cursor: 'pointer', borderRadius: '3px'}}
                        >
                            Sửa
                        </button>
                    </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editingItem && (
          <EditModal 
              item={editingItem} 
              xaPhuongList={xaPhuongList}
              onClose={() => setEditingItem(null)}
              onSave={() => performSearch(currentPage)}
          />
      )}
    </div>
  );
}

export default SearchExport;